<template>
  <div id="index">
    <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl" :coordinationSupplierAuthFlag="coordinationSupplierAuthFlag" :coordinationSystemAuthFlag="coordinationSystemAuthFlag" :supplierManagerAuthFlag="supplierManagerAuthFlag"> </v-topBar>
    <v-notificationTop :noticeInfo="noticeInfo" v-show="showNoticeInfo"></v-notificationTop>
    <v-header class="hidden-xs hidden-sm" :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo' :coordinationSupplierUrl="coordinationSupplierUrl" :recruitPurchaserUrl="recruitPurchaserUrl" :recruitSupplierUrl="recruitSupplierUrl" :supplierManagerUrl="supplierManagerUrl" :coordinationManagerUrl="coordinationManagerUrl" :coordinationSupplierAuthFlag="coordinationSupplierAuthFlag" :coordinationSystemAuthFlag="coordinationSystemAuthFlag" :supplierManagerAuthFlag="supplierManagerAuthFlag" :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl" ></v-header>
    <v-banner :loading="loading" :bannerInfo='bannerInfo' :ratationTime="ratationTime"></v-banner>
    <v-dataCount :paramInfo="paramInfo"></v-dataCount>
    <v-proAndSolut :supplierManagerUrl="supplierManagerUrl" :coordinationManagerUrl="coordinationManagerUrl" :coordinationSupplierUrl="coordinationSupplierUrl" :recruitPurchaserUrl="recruitPurchaserUrl" :recruitSupplierUrl="recruitSupplierUrl" :mroShoppingMallUrl="mroShoppingMallUrl" :coordinationSupplierAuthFlag="coordinationSupplierAuthFlag"></v-proAndSolut>
    <v-operEnterprise></v-operEnterprise>
    <div class="supplierEntry">
      <v-publiceTit :titleObj='titleObj'></v-publiceTit>
      <v-supplierEntryList :supplierEntryInfo='supplierEntryInfo' :viewSupplierUrl="viewSupplierUrl" :warehousingUrl="warehousingUrl" :hitSearchUrl="hitSearchUrl" :viewExamineUrl="viewExamineUrl" :goEnterpriseResourceUrl="goEnterpriseResourceUrl" :coordinationSupplierAuthFlag="coordinationSupplierAuthFlag" :coordinationSystemAuthFlag="coordinationSystemAuthFlag" :supplierManagerAuthFlag="supplierManagerAuthFlag"></v-supplierEntryList>
      <div class="supplierEntryMore">
        <a class="listMore hidden-xs hidden-sm" @click="jump(yellowPage)">MORE</a>
        <a class="listMore hidden-md hidden-lg" @click="mobileBox">MORE</a>
      </div>
    </div>
    <v-serviceCommitment ></v-serviceCommitment>
    <v-footer :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos'></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>
<script>
  import header from '@/components/v-header/header'
  import banner from '@/components/banner'
  import topBar from '@/components/topBar'
  import notificationTop from '@/components/notificationTop'
  import dataCount from '@/components/data-count'
  import proAndSolut from '@/components/proAndSolut'
  import operEnterprise from '@/components/operEnterprise'
  import serviceCommitment from '@/components/serviceCommitment'
  import footer from '@/components/v-footer'
  import publiceTit from '@/components/publiceTit'
  import supplierEntryList from '@/components/supplierEntryList'
  import backToTop from '@/components/backToTop'
  import { mapState } from 'vuex'
  import Cookies from 'js-cookie'
  
  
  export default {
    data () {
      return {
        bannerInfo: [],
        columnType:1,
        webConfigInfo:{},
        paramInfo:{},
        titleObj: {name: '入驻供应商', eng: 'SUPPLIER ENTRY'},
        supplierEntryInfo: [],
        yellowPage:"",
        footerColumnInfos:[],
        warehousingUrl:"",
        navigationColumnInfos:[],
        noticeInfo:[],
        ratationTime:undefined,
        hitSearchUrl:'',
        enterpriseResourceBaseUrl:'',
        yellowPageColumn:{},
        productAndSolutionColumn:{},
        loading:true,
        companyInfo:{},
        orgIdentitys:[],
        companyId:'',
        trueName:'',
        userId:'',
        viewExamineUrl:'',
        goEnterpriseResourceUrl:'',
        userTag:'',
        viewSupplierUrl:'',
        coordinationSupplierAuthFlag:false,
        coordinationSystemAuthFlag:false,
        supplierManagerAuthFlag:false,
        supplierManagerUrl:'',
        coordinationManagerUrl:'',
        coordinationSupplierUrl:'',
        recruitPurchaserUrl:'',
        recruitSupplierUrl:'',
        mroShoppingMallUrl:'',
        showNoticeInfo:true
      }
    },
    computed: mapState([
      'KP'
    ]),
    components: {
      'v-header': header,
      'v-banner': banner,
      'v-dataCount': dataCount,
      'v-topBar': topBar,
      'v-notificationTop': notificationTop,
      'v-proAndSolut': proAndSolut,
      'v-operEnterprise': operEnterprise,
      'v-serviceCommitment': serviceCommitment,
      'v-footer': footer,
      'v-publiceTit': publiceTit,
      'v-supplierEntryList': supplierEntryList,
      'v-backToTop': backToTop
    },
    created () {
      if(this.getToken('isLogin') == 100){
        this.companyInfo = JSON.parse(this.getDAesString(this.getToken('companyInfo'),this.KP.key,this.KP.iv));
        this.userInfo = JSON.parse(this.getDAesString(this.getToken('userInfo'),this.KP.key,this.KP.iv));
        this.userTag = this.userInfo.userTag;
        this.companyId  = this.companyInfo.orgId;
        this.trueName  = this.companyInfo.trueName;
        this.userId  = this.companyInfo.userId;
        let orgIdentity = this.companyInfo.orgIdentity;
        if(orgIdentity !=''){
          this.orgIdentitys = orgIdentity.split(",");
        }
        
      }
      this.$axios.post('/onelink.mdata.main.api/mainInfo/findPreviewMainInfo', {
        columnType: 1,
        positionType: 0,
        receiveObjects: 0,
        currOrgIdentity: this.orgIdentitys,
        currPurchaserId: this.companyId,
        currTrueName:this.trueName,
        currUid: this.userId,
        userTag:this.userTag
      }).then((res) => {
        this.loading=false;
      this.data = res.data;
      this.ratationTime =  Number(this.data.ratationTime)*1000;
      if(Number(this.messageNumber) > 99){
        this.messageNumber = '99+';
      }else{
        this.messageNumber = this.messageNumber;
      }
      this.supplierManagerUrl = this.data.supplierManagerUrl;
      this.coordinationManagerUrl = this.data.coordinationManagerUrl;
      this.coordinationSupplierUrl = this.data.coordinationSupplierUrl;
      this.recruitPurchaserUrl = this.data.recruitPurchaserUrl;
      this.recruitSupplierUrl = this.data.recruitSupplierUrl;
      this.mroShoppingMallUrl = this.data.mroShoppingMallUrl;
      this.noticeInfo = this.data.noticeDtos;
      this.navigationColumnInfos = this.data.navigationColumnInfos;
      this.footerColumnInfos = this.data.footerColumnInfos;
      this.bannerInfo = this.data.bannerPictureInfoDtos;
      this.paramInfo = this.data.paramInfoDto;
      this.webConfigInfo = this.data.webConfigInfoDtoExt;
      this.supplierEntryInfo = this.data.supplierInfo.supplierRecommandResponses;
      this.warehousingUrl = this.data.supplierInfo.warehousingUrl;
      this.viewExamineUrl = this.data.supplierInfo.viewExamineUrl;
      this.goEnterpriseResourceUrl = this.data.supplierInfo.goEnterpriseResourceUrl;
      this.yellowPage = this.data.supplierInfo.supllierUrl;
      this.viewSupplierUrl = this.data.supplierInfo.viewSupplierUrl;
      this.yellowPageColumn = this.data.yellowPageColumn;
      this.productAndSolutionColumn = this.data.productAndSolutionColumn;
      this.hitSearchUrl = this.data.hitSearchUrl;
      this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
      this.coordinationSupplierAuthFlag = this.getToken('coordinationSupplierAuthFlag');
      this.coordinationSystemAuthFlag = this.getToken('coordinationSystemAuthFlag');
      this.supplierManagerAuthFlag = this.getToken('supplierManagerAuthFlag');
    }).catch((err) => {
        console.log(err)
    });
      
    },
    updated(){
      this.hasNotice();
    },
    methods:{
      jump(url){
        window.location.href = url;
      },
      mobileBox(){
        this.$alert('<p>请在PC端查看</p>', '', {
          dangerouslyUseHTMLString: true,
          customClass:'mobileText',
          center: true
        });
      },
      //      判断是否有公告通知
      hasNotice(){
//        console.log('11')
//      console.log(Cookies.get('noticeLength'))
//      console.log(JSON.parse(this.getToken('noticeInfosExt')))
        if(this.getToken('isLogin') == 100){
//        console.log(JSON.parse(this.getToken('noticeInfos')))
          if(JSON.parse(this.getToken('noticeInfos'))){
            if(JSON.parse(this.getToken('noticeInfos')).length>0){
//            console.log('you');
              this.showNoticeInfo = true;
            }else{
              this.showNoticeInfo = false;
            }
          }else{
            this.showNoticeInfo = false;
          }
        }else{
          if(Cookies.get('noticeLength') != 0){
            this.showNoticeInfo = true;
          }else{
            this.showNoticeInfo = false;
          }
        }
        
      }
      
    }
  }
</script>

<style scoped lang="stylus">
  @media only screen and (max-width: 766px)
    .games
      display: none
</style>



// WEBPACK FOOTER //
// src/pages/preview.vue